<template>
  <div>
    <page-header
      :page="pageConfig"
      :actions="pageActionsConfig"
      :has-return="true"
    />
    <create-report-panel
      v-if="createReportVisible"
      :options="reportAvailableAcademicYears"
      @on-continue="$emit('on-continue-create-report', $event)"
      @on-cancel="$emit('on-cancel-report')"
    />
    <div class="row mx-0" v-if="!createReportVisible">
      <div
        class="col-md-4 col-sm-12 d-flex align-items-end flex-column flex-md-row bg-light-gray p-2"
      >
        <custom-drop-down
          v-model="filter.academicYear"
          :clearable="true"
          fieldkey="id"
          fieldname="name"
          :options="academicYears"
          placeholder="Seleccione Año Académico"
          class="flex-grow-1 w-60"
          @input="$emit('on-change-academic-year', filter.academicYear)"
        />
        <action-button
          i="fas fa-search"
          text="Buscar"
          @click="$emit('on-search-result', selectedAcademicYear)"
          variant="success ml-4 mt-4 btn-block-xs-only"
        />
      </div>
    </div>
    <custom-separator class="my-4 mobile-separator" :text="separatorText" />
    <div v-for="(row, idx) of data.result" :key="`result-${idx}`">
      <result-row
        :data="row"
        :has-publish-data-action="canPublishData(row)"
        @on-open-close="onOpenCloseHandler(idx)"
        class="mb-3"
        @on-enter="$emit('on-enter', row.id)"
        @on-publish-data="$emit('on-publish-data', row)"
        :actions="rowActions"
        :show-updated-date="showUpdatedDate"
      >
        <template #submission>
          <div v-if="row.enableSubmission" class="col-12">
            <eden-master-submission
              :data="row"
              @save="saveEnableSubmission"
            ></eden-master-submission>
          </div>
        </template>
        <template #expandablehistory="{ data: rowData }">
          <div class="row bg-secondary-3">
            <div v-if="rowData.showHistory" class="col-12 pa-1">
              <div class="mb-4">
                <status-history-tab :eden-id="rowData.id" bordered>
                  <h6 class="font-weight-bold color-dark mb-0">
                    <i class="fas fa-clock mr-2 text-orange"></i>
                    Historial
                  </h6>
                </status-history-tab>
              </div>
            </div>
          </div>
        </template>
      </result-row>
    </div>
     <custom-result-not-found v-if="data.result.length == 0"
      :text="'No hay información disponible.'"
    />
    <pagination
      v-if="data.pagination.totalItemCount > paginationPageSize"
      :data="data.pagination"
      show-text
      @pagination-go-page="
        $emit('on-change-page', {
          pageIndex: $event,
          academicYear: filter.academicYear || {},
        })
      "
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomSeparator from 'custom-separator';
import Pagination from 'pagination';
import CreateReportPanel from './CreateReportPanel.vue';
import ResultRow from './EdenMasterSearchRow.vue';
import EdenMasterSubmission from './EdenMasterSubmission.vue';
import StatusHistoryTab from '@/views/eden/disputeresolution/history/StatusHistoryTab.vue';
import CustomResultNotFound from "custom-result-not-found";

//constants
import edenStatus from '@/utils/constants/edenStatus.js';
import edenTypes from '@/utils/constants/edenTypes.js';

export default {
  name: 'EdenMasterSearch',
  components: {
    PageHeader,
    CustomDropDown,
    ActionButton,
    CustomSeparator,
    Pagination,
    CreateReportPanel,
    ResultRow,
    EdenMasterSubmission,
    StatusHistoryTab,
    CustomResultNotFound
  },
  props: {
    pageConfig: {
      type: Object,
      default: () => ({
        title: '',
        icon: '',
        routes: [],
      }),
    },
    pageActionsConfig: {
      type: Array,
      default: () => [],
    },
    separatorText: {
      type: String,
      required: true,
    },
    academicYears: {
      type: Array,
      default: () => [],
    },
    reportAvailableAcademicYears: {
      type: Array,
      default: () => [],
    },
    createReportVisible: {
      type: Boolean,
      default: () => false,
    },
    data: {
      type: Object,
      default: () => ({
        result: {},
        pagination: {},
      }),
    },
    paginationPageSize: {
      type: Number,
      default: () => 10,
    },
    selectedAcademicYear: {
      type: Object,
      default: () => {},
    },
    hasPublishDataAction: {
      type: Boolean,
      default: () => false,
    },
    edenReportTypeId: {
      type: Number,
      default: () => -1,
    },
    percentege: {
      type: Number,
      default: () => 0,
    },
    rowActions: {
      type: Array,
      default: () => [],
    },
    showUpdatedDate: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    filter: {
      academicYear: null,
    },
  }),
  computed: {
    canPublishData() {
      return (row) => {
        return (
          row.statusId == edenStatus.SUBMITTED &&
          ((this.edenReportTypeId === edenTypes.CHILD_COUNT &&
            this.userHasPermissions('report.eden.childcount.publish')) ||
            (this.edenReportTypeId === edenTypes.EXIT &&
              this.userHasPermissions('report.eden.exit.publish')) ||
            (this.edenReportTypeId === edenTypes.DISCIPLINE &&
              this.userHasPermissions('report.eden.discipline.publish')) ||
            (this.edenReportTypeId === edenTypes.PERSONNEL &&
              this.userHasPermissions('report.eden.personnel.publish')))
        );
      };
    },
  },
  watch: {
    selectedAcademicYear: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.filter.academicYear = newVal;
        }
      },
    },
  },
  methods: {
    saveEnableSubmission(value) {
      this.$emit('on-save-submission', value);
    },
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 425px) {
  .mobile-separator {
    .separator-custom {
      font-size: 11px !important;
      font-weight: 100 !important;
    }
  }
  .button-mobile-custom {
    width: 95% !important;
  }
}
</style>
